import { DateTimeDisplay } from '../../enums/DateTimeDisplay';
import DateUtils from '../../utils/DateUtils';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Table = styled.div`
    display: grid;
    grid-template-columns: repeat(2, auto);
`

const TableRow = styled.div`
    display: contents;

    @media (max-width: 768px) {
        display: inline-flex;
        gap: var(--cr-spacing-sm);
    }
`

const TableHeading = styled.span.attrs({
    className: 'cr-heading cr-bold',
})`
`

const TableValue = styled.span.attrs({
    className: 'cr-content cr-text-icon',
})`
`

type TProps = {
    startDateTime?: Date;
    endDateTime?: Date;
    dateTimeDisplay: DateTimeDisplay;
    isPrivate: boolean;
};

const LocationDateTime = ({ startDateTime, endDateTime, dateTimeDisplay, isPrivate = false }: TProps) => {
    const { t } = useTranslation();

    if (isPrivate)
    {
        return (
            <div>{t('private-location')}</div>
        );
    }

    const showDate = [DateTimeDisplay.DateTime, DateTimeDisplay.DateOnly].includes(dateTimeDisplay);
    const showTime = [DateTimeDisplay.DateTime, DateTimeDisplay.TimeOnly].includes(dateTimeDisplay);

    return startDateTime ? (
        <div className={'cr-date'}>
            <Table className={'cr-column-gap-sm'}>
                { showDate &&
                    <TableRow>
                        <TableHeading>{t('date')}</TableHeading>
                        <TableValue>
                            {DateUtils.getHumanDate(startDateTime)}
                            { (endDateTime && DateUtils.isDifferentDay(startDateTime, endDateTime)) &&
                                ` t/m ${DateUtils.getHumanDate(endDateTime)}`
                            }
                        </TableValue>
                    </TableRow>
                }
                { showTime &&
                    <TableRow>
                        <TableHeading>{t('time')}</TableHeading>
                        <TableValue>
                            {DateUtils.getHumanTime(startDateTime)}
                            { (endDateTime && DateUtils.isDifferentTime(startDateTime, endDateTime)) &&
                                ` – ${DateUtils.getHumanTime(endDateTime)}`
                            }
                        </TableValue>
                    </TableRow>
                }
            </Table>
        </div>
    ) : null;
}

export default LocationDateTime;
